<template>
  <div class="row shadow">
    <div class="border rounded shadow card col-12 border-0 p-0">
      <div
        class="card-header bg-primary text-white d-flex justify-content-between align-items-center"
      >
        Freunde
        <span class="badge badge-secondary badge-pill rounded">{{
          friendsCount
        }}</span>
      </div>
      <ul class="list-group list-group-flush">
        <li
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          Online
          <span class="badge badge-primary badge-pill rounded">{{
            friendsOnline
          }}</span>
        </li>
        <li
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          Offline
          <span class="badge badge-primary badge-pill rounded">{{
            friendsOfflineCount
          }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { union } from "lodash";

export default {
  computed: {
    isAuth() {
      return this.$store.getters["user/me"] !== null;
    },
    friendsCount() {
      return !this.isAuth ? 0 : this.friends.length;
    },
    friendsOfflineCount() {
      return this.friendsCount - this.friendsOnline;
    },
    friends() {
      return this.$store.getters["user/me"].customer_profile.friends.map(
        friend => friend.id
      );
    },
    online() {
      return union(
        this.$store.getters["online/onlines"]
          .map(online => online.c)
          .concat(Laravel.online)
      );
    },
    friendsOnline() {
      if (!this.isAuth) {
        return 0;
      }

      return this.friends.reduce((accumulator, friend) => {
        return (accumulator += this.online.includes(friend) ? 1 : 0);
      }, 0);
    }
  }
};
</script>
